module.exports = __webpack_public_path__ + "fonts/Biotif-ExtraBold.a8523f3.ttf";